import {
  ArrowLeftIcon,
  Heading,
  IconButton,
  WandSparklesIcon,
} from '@buffer-mono/popcorn'

import styles from './Breadcrumb.module.css'

import type { JSX } from 'react'

/**
 *
 */
function Breadcrumb({
  onGoBack,
}: {
  onGoBack: (() => void) | null
}): JSX.Element {
  return (
    <div className={styles.wrapper}>
      {onGoBack && (
        <IconButton
          variant="tertiary"
          label="Go back"
          data-testid="ai-assistant-back-button"
          onClick={onGoBack}
        >
          <ArrowLeftIcon />
        </IconButton>
      )}
      <div className={styles.activeItem}>
        <WandSparklesIcon />
        <Heading as="h4">AI Assistant</Heading>
      </div>
    </div>
  )
}

export { Breadcrumb }
